import React, { FC } from 'react';

import { CloseButton } from '../../../common/components/Button';
import { Modal } from '../Modal';
import s from './styles.scss';

interface Props {
  src: string;
  close: () => void;
}

export const ImageModal: FC<Props> = ({ src, close }) => (
  <Modal close={close}>
    <img src={src} className={s.modal} alt="" />
    <CloseButton className={s.x} onClick={close} />
  </Modal>
);
